<template>
  <div>
    <!-- breadcrumb start -->
    <breadcrumb-one banner_height="page-banner-height-2" title="About Us" subtitle="About Us"></breadcrumb-one>
    <!-- breadcrumb end -->
    <div class="about-area pt-80 pb-80" style="background-image:url(/images/bg/about-bg.png);">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-6 col-lg-6">
            <div class="about-content"><span>ABOUT OUR ONLINE STORE</span>
              <h4>Hello,</h4>
              <h5 class="banner-t mb-30">With 25+ Years Of Experience</h5>
              <p class="about-text">Over 25 years Dukamarket helping companies reach their <br> financial and branding
                goals.</p>
              <p>The perfect way to enjoy brewing tea on low hanging fruit to identify. Duis autem vel eum iriure dolor
                in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis.
                For me, the most important part of improving at photography.</p>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6">
            <div class="about-image w-img"><img src="/images/about/about-b.png" alt=""></div>
          </div>
        </div>
      </div>
    </div>
   
  </div>
</template>

<script>
import BreadcrumbOne from '@/components/breadcrumb/breadcrumb-one.vue'
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "About",
  components: {
    BreadcrumbOne,
  },
};
</script>

<style scoped>
/* Add styles for Home page */
</style>